import { createFileRoute } from '@tanstack/react-router';
import SigninOidcPage from 'pages/SigninOidc';

export const Route = createFileRoute('/signin-oidc')({
  component: SigninOidcPage,
});
